module.exports = __webpack_public_path__ + "img/event_send.b3c54838.png";